import { ProductSectionStatusType } from '@core/dto/product-section-statuses.dto';
import { Field, Model, PrimitiveSerializer, Type } from '@junte/serialize-ts';

import { BaseModel } from './base-model';

export type ProductSectionType = keyof ProductSectionStatuses;

@Model()
export class ProductSectionStatuses extends BaseModel {
  @Field()
  @Type(new PrimitiveSerializer())
  public emission: ProductSectionStatusType;

  @Field()
  @Type(new PrimitiveSerializer())
  public screening: ProductSectionStatusType;

  public static create(data: Partial<ProductSectionStatuses> | string): ProductSectionStatuses {
    return Object.assign(new ProductSectionStatuses(), data);
  }
}
